import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const InsuranceSlabPropTypes = PropTypes.shape({
  rtoZone: PropTypes.string,
  policyType: PropTypes.string,
  fuelType: PropTypes.string,
});

export const InsuranceSlabDefaultProps = {
  rtoZone: '',
  policyType: '',
  fuelType: ''
};

export const InsuranceSlabYupSchema = Yup.object().shape({
  rtoZone: Yup.string(),
  policyType: Yup.string(),
  fuelType: Yup.string(),
});

export default {
  InsuranceSlabPropTypes,
  InsuranceSlabDefaultProps,
  InsuranceSlabYupSchema,
};
